import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateUrl',
  standalone: false,
})
export class TruncateUrlPipe implements PipeTransform {
  transform(value: string, limit: number): string {
    if (!value) return value;
    let shortened = value.length > limit ? value.substring(0, limit) + '...' : value;
    return shortened;
  }
}
